import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Locations from "@/pages/Locations";
import Sectors from "@/pages/Sectors";
import Quote from "@/pages/Quote";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

let lenis = null;

const SmoothScroll = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let id = requestAnimationFrame(function raf(time) { lenis.raf(time); id = requestAnimationFrame(raf); });
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenis = null; };
  }, []);
  useEffect(() => {
    const t = setTimeout(() => {
      const el = hash ? document.querySelector(hash) : null;
      if (el) (lenis ? lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView());
      else (lenis ? lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0));
    }, hash ? 120 : 0);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};

const Layout = () => (
  <>
    <SmoothScroll />
    <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-[60] focus:bg-white focus:p-3">Skip to content</a>
    <Header />
    <main id="main"><Outlet /></main>
    <Footer />
    <WhatsAppFab />
  </>
);

const PAGES = [["", Home], ["about", About], ["services", Services], ["services/:slug", ServiceDetail], ["locations", Locations], ["sectors", Sectors], ["quote", Quote], ["contact", Contact]];

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {["/", "/ar"].map((prefix) => (
          <Route key={prefix} path={prefix} element={<Layout />}>
            {PAGES.map(([p, C]) => (p === "" ? <Route key="index" index element={<C />} /> : <Route key={p} path={p} element={<C />} />))}
            <Route path="*" element={<NotFound />} />
          </Route>
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
